<div class="flex flex-col h-full">
    <div class="grid grid-cols-1 lg:grid-cols-1 items-start gap-8 flex-1 overflow-y-auto">
        @if(!_orderWizardService.loading$()) {
            <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
        }
        @else {
            <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
        }
    </div>
</div>

<ng-template #component_loading>
    <corp-loading></corp-loading>
</ng-template>

<!-- <ng-template #component_loaded>
    <corp-card class="h-full" [corp-content]="tp_corp_card_user_exception_info"></corp-card>
</ng-template> -->

<ng-template #component_loaded>
    <div class="trezo-card h-full bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
        <div class="trezo-card-content h-full">
            <div class="flex items-center justify-between">
                <div class="flex items-center">
                    <span class="material-symbols-outlined text-danger-500 !text-4xl leading-none">
                        zone_person_urgent
                    </span>
                    <div class="ltr:ml-[12px] rtl:mr-[12px]">
                        <span class="block text-md mb-[2px] font-medium text-black dark:text-white">
                            <!-- i18n: Your itsme profile is incomplete -->
                            {{ 'i18n.app.features.pages.order.wizard.step_03.customer-exception-summary_span_01' | translate }}
                        </span>
                        <span class="block">
                            
                        </span>
                    </div>
                </div>
            </div>
            <ul class="mt-[17px]">
                @for(item of businessExceptionMessages; track item) {
                    <li class="mb-[9px] last:mb-0">
                        <span class="text-black dark:text-white">
                            {{ item.code }}
                        </span>
                        {{item.label}}
                    </li>
                }
            </ul>
            <div class="pt-10">
                <!-- i18n: Please complete your itsme profile before continuing -->
                {{ 'i18n.app.features.pages.order.wizard.step_03.customer-exception-summary_div_01' | translate }}
            </div>
            
        </div>
    </div>
</ng-template>